/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingUserEnvironment } from './BookingUserEnvironment';
import {
    BookingUserEnvironmentFromJSON,
    BookingUserEnvironmentFromJSONTyped,
    BookingUserEnvironmentToJSON,
    BookingUserEnvironmentToJSONTyped,
} from './BookingUserEnvironment';
import type { RateUpdateType } from './RateUpdateType';
import {
    RateUpdateTypeFromJSON,
    RateUpdateTypeFromJSONTyped,
    RateUpdateTypeToJSON,
    RateUpdateTypeToJSONTyped,
} from './RateUpdateType';
import type { RateType } from './RateType';
import {
    RateTypeFromJSON,
    RateTypeFromJSONTyped,
    RateTypeToJSON,
    RateTypeToJSONTyped,
} from './RateType';

/**
 * A request to book a hotel room
 * @export
 * @interface BookingRequest
 */
export interface BookingRequest {
    /**
     * If set to `true`, the booking will not be processed
     * @type {boolean}
     * @memberof BookingRequest
     */
    test?: boolean;
    /**
     * IP address from client.
     * @type {string}
     * @memberof BookingRequest
     */
    customerIp: string;
    /**
     * If the rate type is 'expedia', then this is the expedia booking token. If the rate type is 'direct', then this is the rate id. If the rate type is 'travelport', then this is the rate key.
     * @type {string}
     * @memberof BookingRequest
     */
    bookingToken: string;
    /**
     * Given name of individual booking the room
     * @type {string}
     * @memberof BookingRequest
     */
    givenName: string;
    /**
     * Family name of individual booking the room
     * @type {string}
     * @memberof BookingRequest
     */
    familyName: string;
    /**
     * Email address of individual booking the room
     * @type {string}
     * @memberof BookingRequest
     */
    emailAddress: string;
    /**
     * Phone number including country code
     * @type {string}
     * @memberof BookingRequest
     */
    phoneNumber: string;
    /**
     * Special request to be passed onto the hotel for booking
     * @type {string}
     * @memberof BookingRequest
     */
    specialRequest?: string;
    /**
     * Payment ID referencing a payment_method on the trips service
     * @type {string}
     * @memberof BookingRequest
     */
    paymentId: string;
    /**
     * The loyalty account ID of the user to use for this booking request
     * @type {string}
     * @memberof BookingRequest
     */
    loyaltyAccountId?: string;
    /**
     * Use available credits if available. If set to `true`, and there are credits available, `payment_id` will be ignored.
     * @type {boolean}
     * @memberof BookingRequest
     */
    useAvailableCredits?: boolean;
    /**
     * Skip confirmation email send if `false` - rate update case
     * @type {boolean}
     * @memberof BookingRequest
     */
    sendConfirmationEmail?: boolean;
    /**
     * 
     * @type {RateUpdateType}
     * @memberof BookingRequest
     */
    rateUpdateType?: RateUpdateType;
    /**
     * On rate-update bookings, the user_hotel_stay being replaced. Carries through to api_email_parser so it can record a savings ledger row pairing old + new stays. Optional; required only for INTERNAL/EXTERNAL rate-update flows when callers want savings recorded.
     * @type {string}
     * @memberof BookingRequest
     */
    sourceHotelStayId?: string;
    /**
     * 
     * @type {RateType}
     * @memberof BookingRequest
     */
    rateType: RateType;
    /**
     * 
     * @type {string}
     * @memberof BookingRequest
     */
    scheduledEventCode?: string;
    /**
     * 
     * @type {BookingUserEnvironment}
     * @memberof BookingRequest
     */
    userEnvironment?: BookingUserEnvironment;
    /**
     * Client-generated UUID for idempotency. If provided, the server will check for an existing booking with this ID before processing. Retried requests with the same ID will return the existing booking instead of creating a duplicate.
     * @type {string}
     * @memberof BookingRequest
     */
    bookingRequestId?: string;
    /**
     * The client can render a Stripe 3DS challenge. When true, a booking refused pending a 3DS challenge carries `three_ds_client_secret` on the response so the client can run the challenge and retry the booking.
     * @type {boolean}
     * @memberof BookingRequest
     */
    supportsThreeDsChallenge?: boolean;
}



/**
 * Check if a given object implements the BookingRequest interface.
 */
export function instanceOfBookingRequest(value: object): value is BookingRequest {
    if (!('customerIp' in value) || value['customerIp'] === undefined) return false;
    if (!('bookingToken' in value) || value['bookingToken'] === undefined) return false;
    if (!('givenName' in value) || value['givenName'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    if (!('emailAddress' in value) || value['emailAddress'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('paymentId' in value) || value['paymentId'] === undefined) return false;
    if (!('rateType' in value) || value['rateType'] === undefined) return false;
    return true;
}

export function BookingRequestFromJSON(json: any): BookingRequest {
    return BookingRequestFromJSONTyped(json, false);
}

export function BookingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'test': json['test'] == null ? undefined : json['test'],
        'customerIp': json['customer_ip'],
        'bookingToken': json['booking_token'],
        'givenName': json['given_name'],
        'familyName': json['family_name'],
        'emailAddress': json['email_address'],
        'phoneNumber': json['phone_number'],
        'specialRequest': json['special_request'] == null ? undefined : json['special_request'],
        'paymentId': json['payment_id'],
        'loyaltyAccountId': json['loyalty_account_id'] == null ? undefined : json['loyalty_account_id'],
        'useAvailableCredits': json['use_available_credits'] == null ? undefined : json['use_available_credits'],
        'sendConfirmationEmail': json['send_confirmation_email'] == null ? undefined : json['send_confirmation_email'],
        'rateUpdateType': json['rate_update_type'] == null ? undefined : RateUpdateTypeFromJSON(json['rate_update_type']),
        'sourceHotelStayId': json['source_hotel_stay_id'] == null ? undefined : json['source_hotel_stay_id'],
        'rateType': RateTypeFromJSON(json['rate_type']),
        'scheduledEventCode': json['scheduled_event_code'] == null ? undefined : json['scheduled_event_code'],
        'userEnvironment': json['user_environment'] == null ? undefined : BookingUserEnvironmentFromJSON(json['user_environment']),
        'bookingRequestId': json['booking_request_id'] == null ? undefined : json['booking_request_id'],
        'supportsThreeDsChallenge': json['supports_three_ds_challenge'] == null ? undefined : json['supports_three_ds_challenge'],
    };
}

export function BookingRequestToJSON(json: any): BookingRequest {
    return BookingRequestToJSONTyped(json, false);
}

export function BookingRequestToJSONTyped(value?: BookingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'test': value['test'],
        'customer_ip': value['customerIp'],
        'booking_token': value['bookingToken'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'email_address': value['emailAddress'],
        'phone_number': value['phoneNumber'],
        'special_request': value['specialRequest'],
        'payment_id': value['paymentId'],
        'loyalty_account_id': value['loyaltyAccountId'],
        'use_available_credits': value['useAvailableCredits'],
        'send_confirmation_email': value['sendConfirmationEmail'],
        'rate_update_type': RateUpdateTypeToJSON(value['rateUpdateType']),
        'source_hotel_stay_id': value['sourceHotelStayId'],
        'rate_type': RateTypeToJSON(value['rateType']),
        'scheduled_event_code': value['scheduledEventCode'],
        'user_environment': BookingUserEnvironmentToJSON(value['userEnvironment']),
        'booking_request_id': value['bookingRequestId'],
        'supports_three_ds_challenge': value['supportsThreeDsChallenge'],
    };
}

